module.exports = __webpack_public_path__ + "autopilot-3-ad30782f3dbec61cf1d44ce31253e258.webp";